import Util from "../utils/Util";
import { api } from "./api";

class DeparaService {
  async getTeste(assinaturaId) {
    var retorno = "";
    try {
      var uri = "/cloudplus/depara" + "?assinaturaId=" + assinaturaId;

      retorno = await api.get(uri, Util.getTokenAPIBackEnd());
      return retorno.data;
    } catch (error) {
      return [];
    }
  }
}

export default new DeparaService();
